import { getClient } from "config/apollo";

import type { QueryOptions } from "@apollo/client";

export const getApolloClient = () => getClient();

export async function gqlQuery<TData>(options: QueryOptions): Promise<{ data: TData }> {
  const { data } = await getClient().query<TData>(options);
  if (data == null) {
    throw new Error("Apollo query returned no data");
  }
  return { data };
}
